import { BlocoQr } from '../../componentes/BlocoQr.js';
import { Botao } from '../../componentes/Botao.js';
import { PainelLateral } from '../../componentes/PainelLateral.js';
import type { Dispositivo, PareamentoGerado } from '../../api/dispositivos.js';
import './PainelDePareamento.css';

type Props = {
  readonly dispositivo: Dispositivo;
  readonly pareamento: PareamentoGerado;
  readonly aoFechar: () => void;
};

/**
 * O código de pareamento, mostrado uma única vez (RF-003).
 *
 * O middleware guarda só o SHA-256 — fechar este painel apaga o código de vez,
 * e a tela diz isso antes de a pessoa fechar. Se ele se perder, o caminho é
 * gerar outro, não recuperar este.
 *
 * O QR é desenhado aqui, no navegador (`BlocoQr`): mandar uma credencial de
 * aparelho para um gerador de imagem de terceiros seria entregá-la de bandeja
 * (RNF-026).
 */
export function PainelDePareamento({ dispositivo, pareamento, aoFechar }: Props) {
  return (
    <PainelLateral
      titulo={`Parear ${dispositivo.identificador}`}
      subtitulo="Leia o QR pelo app do coletor. Sem câmera, digite o conteúdo abaixo."
      aoFechar={aoFechar}
      rodape={
        <Botao variante="primario" onClick={aoFechar}>
          Concluí o pareamento
        </Botao>
      }
    >
      <div className="pareamento">
        <BlocoQr
          conteudo={pareamento.conteudoQr}
          expiraEm={pareamento.expiraEm}
          descricao={`QR de pareamento de ${dispositivo.identificador}`}
        />

        <p className="pareamento__aviso" role="note">
          Este código aparece uma única vez. O middleware guarda só o resumo dele — se esta tela
          fechar, o caminho é gerar um novo código.
        </p>

        <ol className="pareamento__passos">
          <li>Abra o app no aparelho e escolha parear.</li>
          {/*
            "o conteúdo", e não "o código": o app só aceita o texto inteiro do
            QR. O código sozinho não leva o endereço da API nem o tenant, e um
            coletor ainda não pareado não tem de onde tirá-los. Enquanto esta
            linha dizia "digite o código", ela mandava o operador fazer algo que
            o app recusa — e foi assim que o defeito apareceu no primeiro teste
            em aparelho.
          */}
          <li>Aponte a câmera para o QR — ou, sem câmera, digite o conteúdo mostrado acima.</li>
          <li>O aparelho passa a Ativo assim que o vínculo é aceito.</li>
        </ol>
      </div>
    </PainelLateral>
  );
}
